var React = require('react');

function ChevronUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M57.44 44.264L32 19.736 6.56 44.264","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronUpInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ChevronUpInline;

ChevronUpInline.default = ChevronUpInline;
